import { render, staticRenderFns } from "./404NotFound.vue?vue&type=template&id=68d1507a&scoped=true&"
import script from "./404NotFound.vue?vue&type=script&lang=js&"
export * from "./404NotFound.vue?vue&type=script&lang=js&"
import style0 from "./404NotFound.vue?vue&type=style&index=0&id=68d1507a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d1507a",
  null
  
)

export default component.exports